import { useValidationContext } from 'context/validation';

import { Message } from 'components/form-elements/Message';

type Props = {
  name: string;
  placeholder?: string;
};

export const FormError = ({ name, placeholder }: Props) => {
  const { getError } = useValidationContext();
  const errorMessages = name && getError(name, placeholder);

  if (!errorMessages || errorMessages.length === 0) {
    return null;
  }

  return (
    <>
      {errorMessages.map((item, i) => (
        <Message key={i} id={`${name}-error`} error>
          <p>{item}</p>
        </Message>
      ))}
    </>
  );
};
